import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import {performSignedFileQuery} from 'external-files/ExternalFileUtils';
import {ExternalEntryProtocolTabState} from 'notebook/entries/backbone/tabs/ExternalEntryProtocol';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import ExternalFileOptions from './ExternalFileOptions';
import ExternalFilePreview from './ExternalFilePreview';

export class ExternalEntryProtocolOptionsView extends Backbone.View<ExternalEntryProtocolTabState> {
  override initialize(): void {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model.externalFile(), 'change:previewType change:url', this.render);
  }

  override render(): this {
    renderToDOM(
      <ExternalFileOptions
        availablePreviewTypes={this.model.externalFile().availablePreviewTypes()}
        name={this.model.get('title')}
        previewType={this.model.externalFile().previewType()}
        updateName={(name: string): void => {
          this.model.set({title: name});
          this.model.updateName(name);
        }}
        updatePreviewType={(previewType) => {
          this.model.updatePreviewType(previewType);
        }}
        generateDownloadUrl={async (isPreview) =>
          await performSignedFileQuery(
            this.model.externalFile().externalFileId(),
            this.model.externalFile().externalFileURL(),
            this.model.owningEntityApiId()
          )
        }
        printHandler={this.model.printHandler.bind(this.model)}
        printOptions={this.model.printOptions()}
        closeTab={() => {
          this.model.close();
        }}
      />,
      this.el
    );
    return this;
  }

  override remove(): Backbone.View<ExternalEntryProtocolTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

export class ExternalEntryProtocolTabView extends Backbone.View<ExternalEntryProtocolTabState> {
  static initClass(): void {
    this.prototype.className = 'external-file-wrapper buffer-tab buffer-tab--no-padding';
  }

  override initialize(): void {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model.externalFile(), 'change:previewType change:url', this.render);
  }

  override render(): this {
    renderToDOM(
      <ExternalFilePreview
        url={this.model.externalFile().externalFileURL()}
        externalFileId={this.model.externalFile().externalFileId()}
        previewType={this.model.externalFile().previewType()}
        owningEntityApiId={this.model.owningEntityApiId()}
      />,
      this.el
    );
    return this;
  }

  override remove(): Backbone.View<ExternalEntryProtocolTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
ExternalEntryProtocolTabView.initClass();
